<app-hero-section />
<app-category-section />
<app-about-section />
<app-faq-section />
